// 吃瓜前线 · 演示数据（静态展示用，后续可替换为真实信源）
export const heroTags = [
  "热播剧番位",
  "综艺修罗场",
  "官宣即塌房",
  "品牌解约",
  "剧组掰头",
  "演唱会加场",
];

// 实时快报
export type Bulletin = {
  id: string;
  time: string;
  category: string;
  title: string;
  summary: string;
  tag?: string;
};

export const liveBulletins: Bulletin[] = [
  {
    id: "b01",
    time: "12:46",
    category: "娱乐",
    title: "《星河背对背》官微放预告第三弹，两位主演同框镜头不足五秒",
    summary: "网友扒出正片开场曲只署名一人，番位争议讨论量一小时内上涨三成。",
    tag: "新进展",
  },
  {
    id: "b02",
    time: "12:18",
    category: "综艺",
    title: "《王牌对王牌之夜》录制现场被爆因流程变动提前三小时结束",
    summary: "多位站姐拍到大巴提前离场，节目组暂未就“删减环节”作出回应。",
    tag: "多方报道",
  },
  {
    id: "b03",
    time: "11:52",
    category: "品牌",
    title: "某国民零食品牌官宣新代言人，前代言方隔空发声明引猜测",
    summary: "两条官博发布时间仅隔十二分钟，评论区已开始分析合同空窗期。",
    tag: "待证实",
  },
  {
    id: "b04",
    time: "11:24",
    category: "剧组",
    title: "《长安十二时辰外传》路透流出造型撞型，造型团队紧急回应",
    summary: "造型师发文称“非最终版本”，但原图早被搬运至数个搬运号。",
    tag: "官方回应",
  },
  {
    id: "b05",
    time: "10:57",
    category: "圈内",
    title: "音乐平台上线歌单“清醒点”，被解读为暗指近期恋爱传闻",
    summary: "歌单创建时间与绯闻曝出仅隔一天，吃瓜区讨论已过万楼。",
    tag: "新进展",
  },
  {
    id: "b06",
    time: "10:31",
    category: "娱乐",
    title: "某卫视跨年晚会拟邀名单流出，一线与新人同台配置引热议",
    summary: "名单目前仅为拟邀，主办方强调“一切以官宣为准”。",
    tag: "待证实",
  },
];

// 事件进展时间线
export type TimelineEvent = {
  id: string;
  title: string;
  category: string;
  heat: number;
  progress: number; // 0-100
  summary: string;
  updates: { time: string; tag: string; text: string }[];
};

export const timelineEvents: TimelineEvent[] = [
  {
    id: "e1",
    title: "《星河背对背》番位风波全记录",
    category: "娱乐",
    heat: 98,
    progress: 82,
    summary: "从开播前的海报排序争议，到官微接连编辑转发，再到双方工作室下场，事件持续发酵超过一周，是当前热度最高的一条长线瓜。",
    updates: [
      { time: "第1天", tag: "开端", text: "官方首曝双人主视觉海报，评论区注意到署名与画面排位存在差异，番位争议首次出现。" },
      { time: "第3天", tag: "发酵", text: "豆瓣开分前剧方上线单人版预告，两人镜头时长被逐帧统计，相关讨论登上热搜。" },
      { time: "第5天", tag: "多方报道", text: "多家娱乐媒体先后报道“二番坚持不改序”，剧方未置评，粉丝组织开始集体发声。" },
      { time: "第7天", tag: "官方回应", text: "两位主演工作室前后发布声明，措辞措辞被逐句拆解，事件热度冲至本周峰值。" },
      { time: "第9天", tag: "最新", text: "官微上线最新一版海报并附长文说明分工与排位口径，评论区态度两极，本站持续跟进后续。" },
    ],
  },
  {
    id: "e2",
    title: "某国民零食品牌代言更换疑云",
    category: "品牌",
    heat: 86,
    progress: 58,
    summary: "前代言人刚发布告别动态，新代言官宣随即跟进，两条消息间隔极短，让“是否提前解约”成为核心争议。",
    updates: [
      { time: "第1天", tag: "开端", text: "前代言人发布一条配乐清冷的告别动态，未点名任何品牌，评论区开始猜测合约结束。" },
      { time: "第2天", tag: "发酵", text: "品牌方十二分钟后官宣新代言人，旧物料仍未下架，两侧粉丝就“体面与否”争论升级。" },
      { time: "第3天", tag: "待证实", text: "有从业者爆料称实际交接期为一个月，但未附合同佐证，本站标注为未经证实消息。" },
    ],
  },
  {
    id: "e3",
    title: "《王牌对王牌之夜》录制动向",
    category: "综艺",
    heat: 74,
    progress: 41,
    summary: "录制时间临时调整引发“环节被砍”的猜测，节目组迟迟未回应，站姐流出的时间表成为主要证据。",
    updates: [
      { time: "第1天", tag: "开端", text: "多位站姐拍到艺人提前离开录制场地，原定十二小时的录制提前三小时结束。" },
      { time: "第2天", tag: "多方报道", text: "有博主放出节目流程表局部，疑似某竞技环节被整体移除，粉丝要求官方给说法。" },
      { time: "第3天", tag: "最新", text: "节目组官微发布录制花絮，但未直接回应删减争议，本期正片排期暂未变动。" },
    ],
  },
  {
    id: "e4",
    title: "《长安十二时辰外传》路透撞型",
    category: "剧组",
    heat: 66,
    progress: 35,
    summary: "提前流出的造型路透与另一热播古装剧风格高度相似，造型团队紧急回应“非最终版”，但原图传播已难阻止。",
    updates: [
      { time: "第1天", tag: "开端", text: "多张片场造型路透被搬运，网友指出披风与冠饰设计与此前热播剧有相似之处。" },
      { time: "第2天", tag: "官方回应", text: "造型团队发文澄清为中间稿，承诺正片将优化细节，但原图已在各平台广泛转发。" },
      { time: "第3天", tag: "最新", text: "片方公布概念物料侧面回应风格差异，事件热度逐步回落，本站仍保留进度追踪。" },
    ],
  },
];

// 热点话题榜
export type HotTopic = {
  id: string;
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: "up" | "down" | "flat" | "new";
};

export const hotTopics: HotTopic[] = [
  { id: "h1", rank: 1, title: "《星河背对背》番位后续", category: "娱乐", heat: 9824, trend: "up" },
  { id: "h2", rank: 2, title: "跨年晚会拟邀名单", category: "综艺", heat: 8741, trend: "up" },
  { id: "h3", rank: 3, title: "零食品牌双代言风波", category: "品牌", heat: 7632, trend: "up" },
  { id: "h4", rank: 4, title: "歌单《清醒点》暗语", category: "圈内", heat: 6558, trend: "new" },
  { id: "h5", rank: 5, title: "录音棚分轨流出事件", category: "圈内", heat: 5423, trend: "down" },
  { id: "h6", rank: 6, title: "路透撞型与造型整改", category: "剧组", heat: 4317, trend: "flat" },
  { id: "h7", rank: 7, title: "综艺剪辑争议再引战", category: "综艺", heat: 3890, trend: "down" },
  { id: "h8", rank: 8, title: "品牌方微博编辑记录", category: "品牌", heat: 3221, trend: "up" },
];

// 频道分类
export type Channel = {
  id: string;
  name: string;
  desc: string;
  count: number;
  tone: "primary" | "accent" | "secondary";
};

export const channels: Channel[] = [
  { id: "c1", name: "娱乐八卦", desc: "艺人动态、剧集番位、作品争议一网打尽", count: 1284, tone: "primary" },
  { id: "c2", name: "综艺现场", desc: "录制花絮、剪辑争议、赛制瓜点逐条同步", count: 856, tone: "accent" },
  { id: "c3", name: "品牌商务", desc: "代言换人、物料下架、微博编辑记录复盘", count: 643, tone: "secondary" },
  { id: "c4", name: "圈内风向", desc: "业内爆料、平台动作与网络热议搬运", count: 502, tone: "accent" },
];

// 常见问题
export type Faq = { q: string; a: string };

export const faqs: Faq[] = [
  {
    q: "吃瓜前线的内容更新频率是怎样的？",
    a: "编辑团队会按事件热度分级跟进：高热事件按分钟级刷新快报，常规话题按小时更新进展，确保你每次回到首页都能看到新变化。",
  },
  {
    q: "一条很长的热门事件，该怎么快速对齐后续？",
    a: "进入事件进展时间线板块，先看顶部的核心进展摘要与关键节点列表，再按时间顺序逐条展开明细，就能在几分钟内对齐整条瓜的前因后果。",
  },
  {
    q: "站内的快报和话题榜单多久刷新一次？",
    a: "热点话题榜每小时根据热度重新排序，实时快报随编辑部跟进实时追加，你也可以点击页面右上角刷新按钮手动拉取最新一版。",
  },
  {
    q: "吃瓜前线的内容来源可信吗？",
    a: "我们坚持优先转载可查证的信源，并对每条进展标注跟进状态（待证实 / 多方报道 / 官方回应），未经证实的传闻会单独归类，帮助大家理性吃瓜。",
  },
  {
    q: "想跟进某个具体话题，可以用关键词搜索吗？",
    a: "可以。在首页顶部搜索框输入艺人名、节目名或事件关键词即可筛选出对应快报与时间线，也支持点击热门标签直接定位到相关板块。",
  },
];